<template>
  <div class="d-flex" style="min-height: calc(100vh - 56px);">
    <!-- Sidebar -->
    <nav class="admin-sidebar bg-white border-end shadow-sm py-4 px-3" style="width: 220px; flex-shrink: 0;">
      <p class="text-uppercase text-muted small fw-semibold mb-3 px-2">Admin</p>
      <ul class="nav flex-column gap-1">
        <li class="nav-item">
          <router-link
            to="/admin/settings"
            class="nav-link rounded px-3 py-2"
            active-class="active-link"
          >
            <i class="fas fa-sliders-h me-2"></i>Settings
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            to="/admin/kill-switch"
            class="nav-link rounded px-3 py-2"
            active-class="active-link"
          >
            <i class="fas fa-power-off me-2 text-danger"></i>Kill Switch
          </router-link>
        </li>
        <li v-if="backtest" class="nav-item">
          <router-link
            to="/admin/backtest"
            class="nav-link rounded px-3 py-2"
            active-class="active-link"
          >
            <i class="fas fa-pause-circle me-2 text-warning"></i>Backtest
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            to="/admin/alpaca-import"
            class="nav-link rounded px-3 py-2"
            active-class="active-link"
          >
            <i class="fas fa-cloud-download-alt me-2 text-primary"></i>Import Trade History
          </router-link>
        </li>
      </ul>
    </nav>

    <!-- Content area -->
    <main class="flex-grow-1 p-4 bg-light">
      <router-view />
    </main>
  </div>
</template>

<script>
import { fetchSystemClock } from '../services/api';

export default {
  name: 'AdminLayout',
  data() {
    return {
      // The Backtest entry (pause control) only makes sense on a backtest
      // stack; the clock endpoint says which this is.
      backtest: false,
    };
  },
  async mounted() {
    try {
      const data = await fetchSystemClock();
      this.backtest = data.backtest === true;
    } catch (err) {
      console.warn('[AdminLayout] could not determine backtest mode:', err.message);
    }
  },
}
</script>

<style scoped>
.admin-sidebar .nav-link {
  color: #6c757d;
  font-weight: 500;
  transition: all 0.2s;
}
.admin-sidebar .nav-link:hover {
  color: #0d6efd;
  background-color: #f0f4ff;
}
.admin-sidebar .active-link {
  color: #0d6efd !important;
  background-color: #e7f1ff;
  font-weight: 600;
}
</style>
